// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"368":"Toast","3789":"Viewer","6383":"RootWidget","9683":"AboutEditComponent"}[chunkId] || chunkId) + ".chunk.min.css";
};